import { CarDetailController } from 'controllers/car-detail-controller';
import { CarSearchController } from './car-search-controller';
import { ChangeSearchController } from './change-search-controller';
import { CarDropOffController } from './car-drop-off-controller';
import { CarRnRController } from './car-rnr-controller';

export const controllers = [CarDetailController, CarDropOffController,CarRnRController, CarSearchController, ChangeSearchController];
